export enum ContentBlockType {
  Image,
  Map
}
